__turbopack_context__.v({
  "active": "style-module-scss-module__uybgKa__active",
  "component": "style-module-scss-module__uybgKa__component",
  "exp": "style-module-scss-module__uybgKa__exp",
  "menu-beta-badge": "style-module-scss-module__uybgKa__menu-beta-badge",
  "menu-item-with-content": "style-module-scss-module__uybgKa__menu-item-with-content",
  "menu-items": "style-module-scss-module__uybgKa__menu-items",
  "mobile": "style-module-scss-module__uybgKa__mobile",
  "nested-arrow": "style-module-scss-module__uybgKa__nested-arrow",
  "nested-header": "style-module-scss-module__uybgKa__nested-header",
  "nested-header-content": "style-module-scss-module__uybgKa__nested-header-content",
  "nested-item-header": "style-module-scss-module__uybgKa__nested-item-header",
  "nested-list": "style-module-scss-module__uybgKa__nested-list",
});
